export default __webpack_public_path__ + "static/media/backgroundBarImage.c0feec71.webp";